<sc-padding class="no-field-space">
  <ac-property-group propertyKey="tmc-yard.weighing.enabled">

    <sc-content-spacer vertical></sc-content-spacer>

    <ac-string-property propertyKey="tmc-yard.weighing.maxWeight"></ac-string-property>

    <sc-sub-title><sc-dictionary-label dictionaryKey="tmc-yard.weighing.ui.weighing-property-administration.title"></sc-dictionary-label></sc-sub-title>

    <ac-string-property propertyKey="tmc-yard.weighing.dialog.scaleKey"></ac-string-property>
    <sc-hint-legacy dictionaryKey="tmc-yard.weighing.ui.weighing-property-administration.scaleKey-subtext"></sc-hint-legacy>

    <sc-content-spacer vertical></sc-content-spacer>

    <sc-sub-title><sc-dictionary-label dictionaryKey="tmc-yard.weighing.ui.weighing-property-administration.entrance-title"></sc-dictionary-label></sc-sub-title>

    <ac-property-group propertyKey="tmc-yard.weighing.entrance.enabled">
      <ac-string-property propertyKey="tmc-yard.weighing.entrance.minLength"></ac-string-property>
      <ac-string-property propertyKey="tmc-yard.weighing.entrance.type"></ac-string-property>
      <sc-hint-legacy dictionaryKey="tmc-yard.weighing.ui.weighing-property-administration.type-subtext"></sc-hint-legacy>
      <ac-string-property propertyKey="tmc-yard.weighing.entrance.scaleKey"></ac-string-property>
      <sc-hint-legacy dictionaryKey="tmc-yard.weighing.ui.weighing-property-administration.scaleKey-subtext"></sc-hint-legacy>
    </ac-property-group>

    <sc-content-spacer vertical></sc-content-spacer>

    <sc-sub-title><sc-dictionary-label dictionaryKey="tmc-yard.weighing.ui.weighing-property-administration.leave-title"></sc-dictionary-label></sc-sub-title>

    <ac-property-group propertyKey="tmc-yard.weighing.leave.enabled">
      <ac-string-property propertyKey="tmc-yard.weighing.leave.minLength"></ac-string-property>
      <ac-string-property propertyKey="tmc-yard.weighing.leave.type"></ac-string-property>
      <sc-hint-legacy dictionaryKey="tmc-yard.weighing.ui.weighing-property-administration.type-subtext"></sc-hint-legacy>
      <ac-string-property propertyKey="tmc-yard.weighing.leave.scaleKey"></ac-string-property>
      <sc-hint-legacy dictionaryKey="tmc-yard.weighing.ui.weighing-property-administration.scaleKey-subtext"></sc-hint-legacy>
    </ac-property-group>

  </ac-property-group>

</sc-padding>
